import { Briefcase } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

const PARAGRAPHS = ["p1", "p2", "p3", "p4", "p5"] as const;

export const ConsultingSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="consulting"
      icon={<Briefcase aria-hidden="true" focusable="false" />}
      heading={t("consulting.heading")}
      photo={{ src: "/images/home/consulting-code.jpg" }}
    >
      <div className="consulting-copy">
        {PARAGRAPHS.map((key) => (
          <p key={key} data-reveal>
            {t(`consulting.${key}`)}
          </p>
        ))}
      </div>
    </SectionShell>
  );
};
